import {
  executeQuery,
  firestoreCollection,
} from '../firebase/firestore';

export class Group {
  constructor(groupId, userIds) {
    this.groupId = groupId;
    this.userIds = userIds;
  }

  static async init(organizationId, groupId) {
    const collection = `organizations/${organizationId}/groups/${groupId}/groupUsers`;
    const users = await executeQuery(firestoreCollection(collection));
    const userIds = users.map(user => user.id);

    return new Group(groupId, userIds);
  }

  hasUser(userId) {
    return this.userIds.includes(userId);
  }
}
